import { render, staticRenderFns } from "./billboardBannerMiddle.vue?vue&type=template&id=66b5470d&scoped=true&"
import script from "./billboardBannerMiddle.vue?vue&type=script&lang=js&"
export * from "./billboardBannerMiddle.vue?vue&type=script&lang=js&"
import style0 from "./billboardBannerMiddle.vue?vue&type=style&index=0&id=66b5470d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5470d",
  null
  
)

export default component.exports